import { render } from "./TranslationVariantsPopup.vue?vue&type=template&id=c3734dbc&scoped=true&ts=true"
import script from "./TranslationVariantsPopup.vue?vue&type=script&lang=ts"
export * from "./TranslationVariantsPopup.vue?vue&type=script&lang=ts"

import "./TranslationVariantsPopup.vue?vue&type=style&index=0&id=c3734dbc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3734dbc"]])

export default __exports__